const SEARCH_FIELDS = { 1: 'upc', 2: 'manufacturer', 3: 'subname' }

// wordradio is the keyword followed by one search-field digit
export const parseSearch = (wordradio) => ({
  keyword: wordradio.slice(0, -1),
  field: SEARCH_FIELDS[wordradio.slice(-1)] || 'subname'
})
